import React, { FC, memo } from 'react';
import { Box, Typography, makeStyles } from '@material-ui/core';

interface Props {
  dealsCount: number;
  projectedValue: number;
}

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: theme.spacing(2),
    padding: theme.spacing(1.5, 2),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: 8,
    backgroundColor: theme.palette.background.paper
  },
  label: {
    fontSize: 13,
    fontWeight: 600,
    color: theme.palette.text.secondary,
    textTransform: 'uppercase',
    letterSpacing: 0
  },
  value: {
    fontSize: 14,
    fontWeight: 700,
    color: theme.palette.text.primary
  }
}));

const formatMoney = (value: number) =>
  `₱${Number(value || 0).toLocaleString('en-PH', {
    maximumFractionDigits: 0
  })}`;

const Component: FC<Props> = ({ dealsCount, projectedValue }) => {
  const classes = useStyles();

  return (
    <Box className={classes.root}>
      <Typography className={classes.label}>Summary</Typography>
      <Typography className={classes.value}>
        deals: {dealsCount} | projected value: {formatMoney(projectedValue)}
      </Typography>
    </Box>
  );
};

export const CrmSalesSummary = memo(Component);
